// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__2JTE5","footer":"ReportModalFilter_footer__2BMiH"};